import PuxTable from "../src/PuxTable/PuxTable.vue";

import _PuxTablePlugin from "../src/PuxTable/plugin/PuxTablePlugin";

export default PuxTable;

export const PuxTablePlugin = _PuxTablePlugin;
